<template>
    <div>
        <router-view/>
        <SvgMarkings></SvgMarkings>
        <loader></loader>
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import SvgMarkings from '@mobile/components/global/SvgMarkings';
import Loader from './common/Loader';
import '@css/style.scss';
import '@sass/manager.scss';

export default {
    name: 'DesktopApp',
    components: {SvgMarkings, Loader},
    data() {
        return {}
    },

    created: function () {
        this.$router.beforeEach((to, from, next) => {
            this.loadProject(to.params).finally(() => next());
        });

        this.$http.interceptors.response.use(undefined, function (err) {
            return new Promise(() => {
                if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
                    this.$store.dispatch(logout);
                }
                throw err;
            });
        });
    },

    mounted: function () {
        this.loadUser();
        this.loadProject(this.$route.params);
    },

    methods: {
        logout: function () {
            this.$store.dispatch('logout')
                .then(() => {
                    this.$router.push('/login')
                });
        },

        loadUser: function () {
            if (typeof this.$store.state.user.id === 'undefined') {
                this.$store.dispatch('loadLoggedInUser').then((user) => {
                    this.$store.state.user = user;
                });
            }
        },

        loadProject: function (params) {
            return new Promise((resolve) => {
                if (params && params.id && this.$store.state.company.id && !this.$store.state.project.id) {
                    this.$store.dispatch('loadProject', params.id).finally(() => resolve());
                } else {
                    resolve();
                }
            });
        }
    }
}
</script>
